export interface IUpsell {
  id: number;
  producer_id: number;
  type: number;
  show_type: number;
  content: string;
  description: string;
  title: string;
  highlight_image?: string;
  small_image?: string;
  showcase_image?: string;
  external_url?: string;
  label_text?: string;
  producer?: {
    id: number;
    name: string;
    avatar?: string;
  };
}

export enum enUpsellType {
  checkoutSun = 1,
  nutror = 2,
  externalUrl = 3
}
export interface IUTM {
  utm_medium: string;
}
export enum enUpsellTypeProduct {
  nutror = 0,
  infoProduct = 1,
  services = 2,
  physicalProduct = 3,
  ticket = 4
}

export interface IBannerShowcaseWithConfig {
  upsell: IShowcaseBannerUpsell[];
  schoolConfig?: ISchoolConfig;
}

export interface IShowcaseBannerUpsell
  extends Omit<IUpsell, 'small_image' | 'highlight_image' | 'small_image' | 'showcase_image'> {
  hash: string;
  highlight_images: {
    large?: string;
    medium?: string;
    small?: string;
  };
}

export interface ISchoolConfig {
  id?: number;
  title?: string;
  image?: string;
  old_image?: string;
  thumbnail?: string;
  highlight_banner?: string;
  banner_logo?: string;
}
